// src/config.js
const USE_PRODUCTION = true;

const API_BASE_URL = USE_PRODUCTION
  ? 'https://orionadministracion.com/'
  : 'http://localhost:3000/';

export default API_BASE_URL;
